// extracted by mini-css-extract-plugin
export var closeButton = "_ki-1";
export var closeX = "_ki-3";
export var container = "_ki-0";
export var image = "_ki-2";